import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './NavBar.module.sass';

// Package-selection tab bar. Text-only (the ribbon/box/paper icon graphics were
// dropped to reclaim the vertical room at the top of the screen, 07-23).
//
// Two tabs:
//   Packages               -> ALL packages, featured-first. (Replaces the old "Featured"
//                             and "Packages" tabs. Featured-only would have hidden non-
//                             featured best-sellers like "Digital Value Pack", so this
//                             single tab shows every priced package with the featured ones
//                             leading.)
//   Prints / Digital Files -> navigates to the Photo Gifts & Add Ons page rather than
//                             switching to an in-page prints builder, so it never gets a
//                             persistent "selected" state.
const NavBar = ({ selectedIcon, setSelectedIcon, onPrints }) => (
  <div className={styles.navContainer}>
    <div className={styles.innerWrapper}>
      <button
        type="button"
        className={cn(styles.tab, selectedIcon === 'packages' && styles.selected)}
        onClick={() => setSelectedIcon('packages')}
      >
        Packages
      </button>
      <button
        type="button"
        className={styles.tab}
        onClick={onPrints}
      >
        Prints / Digital Files
      </button>
    </div>
  </div>
);

NavBar.defaultProps = {
  onPrints: () => {},
};

NavBar.propTypes = {
  selectedIcon: PropTypes.string.isRequired,
  setSelectedIcon: PropTypes.func.isRequired,
  onPrints: PropTypes.func,
};

export default NavBar;
